import React, { Component } from "react";
import "./bar-chart.scss";

class ResultChart extends Component {
    results = [
        { label: "A", percent: 18, correct: false },
        { label: "B", percent: 28, correct: false },
        { label: "C", percent: 72, correct: true },
        { label: "D", percent: 6, correct: false }
    ];

    state = {
        labels: ['A', 'B', 'C', 'D', 'E', 'F'],
        adjustedPercentagesData: [],
        correctAnswerPercentage: 0,
        correctlyAnsweredUserCount : 0
    }

    constructor(props) {
        super(props)
        let percentages = []

        // console.log(this.props.studentResponseCount)

        let totalUsersAnsweredCount = 0

        this.props.options.forEach(item => {
            let percentage = (item.usersAnsweredCount / this.props.studentResponseCount) * 100

            totalUsersAnsweredCount += item.usersAnsweredCount
            percentages.push({ ...item, percentage })
        })

        console.log(percentages)

        let adjustedPercentagesData = this.adjustPercentagesInObjects(percentages, "percentage");



        this.state.adjustedPercentagesData = adjustedPercentagesData
        this.state.totalUsersAnsweredCount = totalUsersAnsweredCount
    }

    componentDidMount() {
        if (this.state.adjustedPercentagesData.length) {
            let correctAnswer = this.state.adjustedPercentagesData.filter(item => item.isCorrect === true)
            this.setState({ correctAnswerPercentage: correctAnswer[0].percentage, 
                correctlyAnsweredUserCount : correctAnswer[0].usersAnsweredCount })
        }
    }


    adjustPercentagesInObjects(data, valueKey) {
        console.log(data)
        // Step 1: Round each value
        const roundedValues = data.map(item => ({
            ...item,
            rounded: Math.round(item[valueKey]), // Store rounded value
            fractionalPart: item[valueKey] - Math.floor(item[valueKey]), // Store fractional part
        }));

        // Step 2: Calculate the difference
        const total = roundedValues.reduce((sum, item) => sum + item.rounded, 0);
        const difference = 100 - total;

        console.log(difference)
        // Step 3: Adjust the values
        if (difference !== 0) {
            // Sort by fractional part (descending for adding, ascending for subtracting)
            const sorted = [...roundedValues].sort((a, b) =>
                difference > 0
                    ? b.fractionalPart - a.fractionalPart // Descending for adding
                    : a.fractionalPart - b.fractionalPart // Ascending for subtracting
            );

            console.log(sorted)

            // Apply the adjustment
            for (let i = 0; i < Math.abs(difference); i++) {
                if (sorted[i] && sorted[i].rounded) {
                    sorted[i].rounded += difference > 0 ? 1 : -1;
                }

            }
        }

        // Step 4: Return adjusted data
        return roundedValues.map(item => ({
            ...item,
            [valueKey]: item.rounded, // Update original value with adjusted rounded value
        }));
    }



    renderRow(item, index) {



        const fillClass = item.isCorrect ? "fill fill--correct" : "fill fill--wrong";
        const percentClass = item.isCorrect ? "percent green" : "percent red";

        return (
            <div className="row row-margin" key={this.state.labels[index]} >
                {
                    item.isCorrect ? <div className="col-1 correct-answer-colour">{item.isCorrect && "✓"}</div>
                    :
                    <div className="col-1 wrong-answer"></div>
                }
                <div></div>
                <div className="label">{this.state.labels[index]}</div>

                <div className="track">
                    <div
                        className={fillClass}
                        style={{ width: `${item.percentage}%` }}
                    />
                </div>

                <div className={percentClass}>
                    {item.usersAnsweredCount} {item.isCorrect}{`(${item.percentage}%)`}
                </div>
            </div>
        );
    }

    render() {
        return (
            
                <div className="horizontal-bar-chart">
                    <div className="correct-answer-percentage-text mb-4">{this.state.correctAnswerPercentage}% of the class answered correctly</div>
                    {/* <div className="correct-answer-percentage-text mb-4">{this.state.correctAnswerPercentage}% of the class answered correctly{` ( ${this.state.totalUsersAnsweredCount} / ${this.props.totalStudentsCount} )`}</div> */}
                    {/* <p className="answer">Correct answer: Option C — 24</p> */}
                    {this.state.adjustedPercentagesData.length && this.state.adjustedPercentagesData.map((r, index) => this.renderRow(r, index))}
                </div>
        );
    }
}

export default ResultChart;
